<template>
  <div>
    <HeadlineContainer headline="Publications" :breadcrumbs="[{text: 'Publications'}]"/>

    <div v-if="!loading" class="container">
      <PublicationList :portals="portals" :publication-channels="publicationChannels"/>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import PublicationList from '../../../components/Administration/Publications/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'

export default {
  components: {PublicationList, HeadlineContainer},

  data() {
    return {
      portals: null,
      publicationChannels: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

      Promise.all([
        http.get('/api/v2/portals', {page_size: 100}),
        http.get('/api/v2/publication-based-channels'),
      ]).then(responses => {
        this.portals = responses[0].data.data

        this.publicationChannels = responses[1].data.data

        this.loading = false
      })
    }
  }
}
</script>
